import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: SkillInfoState = {
  visible: false,
  skillId: ''
};

export interface SkillInfoState {
  visible: boolean,
  skillId: string
}

export const slice = createSlice({
  name: 'skillInfo',
  initialState: initialState,
  reducers: {
    show: (state, action: PayloadAction<string>) => {
      state.visible = true;
      state.skillId = action.payload;
    },
    hide: (state) => {
      state.visible = false;
    }
  }
});

export default slice.reducer;
export const { show, hide } = slice.actions;
